import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ReviewReasonComponent } from 'src/app/admin/components/review-reason/review-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let require: any;
const FileSaver = require('file-saver');

@Component({
  selector: 'app-admin-physical-infra',
  templateUrl: './admin-physical-infra.component.html',
  styleUrls: ['./admin-physical-infra.component.css'],
})
export class AdminPhysicalInfraComponent implements OnInit {
  updateForm: FormGroup;
  private getApi = environment.url + environment.phyInfGet;
  private updateStatusApi = environment.url + environment.updateStatus;
  /**
   * Constructs the AdminPhysicalInfraComponent with required services.
   * Initializes the update form and mobile query listener.
   * @param changeDetectorRef Reference to Angular's change detector for triggering change detection.
   * @param media Service to match media queries for responsive design.
   * @param getdata Service to retrieve values or data needed by the component.
   * @param fb FormBuilder service for creating reactive forms.
   * @param makeapi Service for making API calls.
   * @param dialog Material dialog service for opening dialogs.
   * @param notify Service for displaying notifications.
   * @param appCom Reference to the root AppComponent.
   * @param http Angular HttpClient for HTTP requests.
   */
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private getdata: ValueService,
    private fb: FormBuilder,
    private makeapi: ApiService,
    public dialog: MatDialog,
    private notify: NotifyService,
    private appCom: AppComponent,
    private http: HttpClient
  ) {
    // Initialize the update form with an incubator ID field
    this.updateForm = this.fb.group({
      incubatorId: [''],
    });

    // Initialize the mobile query listener to detect changes in the mobile query
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  incubaterName;
  /**
   * Lifecycle hook that is called after the component is initialized.
   * It retrieves the incubator name from session storage, updates the form,
   * fetches data from the API, and retrieves guideline data.
   */
  ngOnInit(): void {
    // Retrieve the incubator name from session storage and assign it to the component property
    this.incubaterName = sessionStorage.getItem('adminIncubName');

    // Get the current form values and update the incubator ID from session storage
    let getform = this.updateForm.value;
    getform.incubatorId = sessionStorage.getItem('incubator');

    // Update the form with the modified values
    this.updateForm.patchValue(getform);

    // Fetch data from the API
    this.getDataApi();

    // Retrieve guideline data
    this.guidelineDatas();
  }
  getValue: any = {};
  /**
   * Fetches data from the API using the incubator ID from session storage,
   * shows a loading indicator during the request, and updates the component's
   * data on success.
   */
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('incubator'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        // Store the data in a variable so that it can be accessed in the template
        this.getValue = data;
      });
  }
  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  /**
   * Initiates a download of a PDF file using the provided URL.
   *
   * @param value - The URL of the PDF to download.
   */
  download(value) {
    const pdfUrl = value; // The URL of the PDF file
    const pdfName = 'your_pdf_file'; // The name under which the PDF will be saved
    // Use the FileSaver library to trigger the download
    FileSaver.saveAs(pdfUrl, pdfName);
  }
  /**
   * Approves an item with the given key and status, and refreshes the data after the API call.
   *
   * @param keys - The unique identifier for the item to approve.
   * @param id - The status of the item to approve.
   */
  approveBtn(keys, id) {
    // Add the key as a control in the form, and set its value to the provided id
    const fc = new FormControl('');
    this.updateForm.addControl(keys, fc);
    this.updateForm.controls[keys].setValue(id);

    // Show a loading indicator until the request is complete
    this.getdata.amizhthLoader('show');

    // Get the current form values
    let getform = this.updateForm.value;

    // Submit the form with the updated values
    this.makeapi
      .method(this.updateStatusApi, getform, 'post')
      .subscribe((data) => {
        // Hide the loading indicator once the request is complete
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          // If the request was successful, notify the user of success
          this.notify.notifysuccess(data.responseMessage);
          // Remove the control from the form
          this.updateForm.removeControl(keys);
          // Refresh the data
          this.getDataApi();
        } else {
          // If the request was not successful, notify the user of an error
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  /**
   * Rejected the item with the given key and status, and refreshes the data after the API call.
   *
   * @param keys - The unique identifier for the item to reject.
   * @param id - The status of the item to reject.
   */
  rejectBtn(keys, id) {
    const fc = new FormControl('');
    this.updateForm.addControl(keys, fc);
    this.updateForm.controls[keys].setValue(id);
    this.getdata.amizhthLoader('show');
    let getform = this.updateForm.value;
    this.makeapi
      .method(this.updateStatusApi, getform, 'post')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          this.updateForm.removeControl(keys);
          this.getDataApi();
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  /**
   * Opens the ReviewReasonComponent dialog to review an item with the given key and status.
   * Refreshes the data after the dialog is closed.
   *
   * @param key - The unique identifier for the item to review.
   * @param status - The current status of the item.
   */
  reviewBtn(key, status) {
    const dialogRef = this.dialog.open(ReviewReasonComponent, {
      width: '390px',
      data: { _key: key, _status: status },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getDataApi(); // Refresh the data
    });
  }
  /**
   * Opens the guidelines modal for the given data
   * @param data - The data for which the guidelines modal should be opened
   */
  guidelinesBtn(data) {
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  /**
   * Retrieves the guidelines data from the JSON file.
   * The data is stored in the `guidelineValue` property.
   */
  guidelineDatas() {
    this.http.get('/assets/json/guideline.json').subscribe((data: any) => {
      // Set the guidelines value to the questions array in the data
      this.guidelineValue = data[4].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.step++;
  }
  prevStep() {
    this.step--;
  }
}
